import { normalize } from 'normalizr';
import endpoints from 'api/endpoints';
import Immutable from 'immutable';
import { article } from 'schemas';

export default ({ id, locale }) => ({
  url: endpoints.getFaqArticleUrl(id, locale),
  transform: response =>
    normalize(response.data, article.schema).entities,
  transformResult: response => ({
    article: normalize(response.data, article.schema).result,
  }),
  meta: {
    authToken: true,
  },
  force: true,
  queryKey: endpoints.getFaqArticleUrl(),
  options: {
    headers: {
      Accept: 'application/json',
    },
  },
  update: {
    article: (prevResult = Immutable.Map(), result) => prevResult.mergeDeep(result),
  },
  updateResult: {
    article: (prevResult, result) => result,
  },
});
